import Vue from 'vue'
import 'brave-sass/default.scss'
import initializeStore from 'brave-vuex/initializeStore'
import Router from 'vue-router'
import {PREVIEW_PATH} from 'brave-build/constants'
import initializeI18n from 'brave-i18n/initializeI18n'
import fontFlashPrevention from 'brave-placeholders/fontFlashPrevention'
import VueMobileDetection from "vue-mobile-detection";

import globalComponentInitialization from 'brave-vue/globalComponentInitialization'
import materialDesignInitialization from 'brave-vue/materialDesignInitialization'

Vue.config.productionTip = true
Vue.config.silent = false
Vue.config.ignoredElements = [
  'altcha-widget'
]

/* eslint-disable no-new */
export default function ({MainComponent, routing, messages}) {
  // Routing
  Vue.use(VueMobileDetection);
  Vue.use(Router);
  // vue-material (MdButton, MdList, etc.) merges props from
  // this.$options.components['router-link'].options.props; Vue Router 3 only registers
  // the PascalCase global. Register the kebab-case alias so that lookup succeeds.
  const RouterLink = Vue.component('RouterLink');
  if (RouterLink) {
    Vue.component('router-link', RouterLink);
  }
  let finalizedRoutes = generatePreviewBuildRoutes(routing.routes)
  routing.routes = finalizedRoutes
  routing.scrollBehavior = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 200)
    })
  }

  let router = new Router(routing)

  // Trailing-slash route aliases (e.g. /login/ for /login) are added in app-entry.js
  // so paths match when the server canonicalizes with a trailing slash.

  globalComponentInitialization()

  materialDesignInitialization()


  // Internationalization
  let i18n = initializeI18n({messages})

  // Data store
  let store = initializeStore()

  fontFlashPrevention()

  return new Vue({
    el: '#brave-app',
    router,
    i18n,
    store,
    render: h => h(MainComponent)
  })
}

function generatePreviewBuildRoutes (baseRoutes) {
  let previewBuildRoutes = [];
  for (let route of baseRoutes) {
    let previewRoute = Object.assign({}, route)
    previewRoute.path = `${PREVIEW_PATH}${route.path}`
    previewBuildRoutes.push(previewRoute)
  }

  return baseRoutes.concat(previewBuildRoutes)
}
